import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, PreviewAltCard, Row } from "../../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import { createBrandAPI, createCategoryAPI, listBrandAPI, listCategoryAPI, updateBrandAPI, updateCategoryAPI } from "../../api/master/indes";

import { toast } from "react-toastify";

import { BASE_URL_IMG } from "../../assets/constants";
import MyButton from "../../MyComp/UI/form/MyButton";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import useLogout from "../../hooks/useLogout";
import { Label } from "reactstrap";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import { DataTableData } from "../../pages/components/table/TableData";
import Table from "../../MyComp/UI/DataTable/Table";
import SubCategoryTable from "../../MyComp/UI/DataTable/SubCategoryTable";

import Select from "react-select";

const Category = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
      tableLoading: false,
    },
  });
  const logout = useLogout();
  const [isOpenc, setIsOpenc] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);
  const [openCanvas, setOpenCanvas] = useState(false);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));

  useEffect(() => {
    getCategoryList();
  }, []);
  const getCategoryList = () => {
    setValue("tableLoading", true)
    listCategoryAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data);
          setValue("isLoading", false);
        } else {
          setData([]);
          setValue("isLoading", false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();

    formData.append("order", watch("order"));
    formData.append("status", watch("status")?.value);

    if (watch("category_img")) {
      formData.append("img", watch("category_img"));
    }

    const selected = watch("selectedRow");

    if (watch("addSub")) {
      formData.append("parent_id", selected?.parent_id || selected?.id);
      formData.append("name", watch("subCategory"));
    } else {
      formData.append("name", watch("category"));
    }

    if (mode === "Edit") {
      formData.append("id", selected?.id);

      updateCategoryAPI(formData)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            getCategoryList();
            setIsOpen(false);
            setValue("isLoading", false);
            resetF();
          } else if (res.data.status === "expired") {
            toast.error(res.data.message);
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });

    } else {
      createCategoryAPI(formData)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            getCategoryList();
            setIsOpen(false);
            setValue("isLoading", false);
            resetF();
          } else if (res.data.status === "expired") {
            toast.error(res.data.message);
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Edit");
    setValue("selectedRow", row);

    const isSub = !!row.parent_id;
    setValue("addSub", isSub);

    if (!isSub) {
      // Main Category
      setValue("category", row?.name);
    } else {
      // Sub Category
      setValue("subCategory", row?.name);

      const parent = data.find((d) => d.id === row.parent_id);
      setValue("category", parent?.name || "");
    }

    setValue("order", row?.order);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });

    setValue(
      "category_image",
      row.image ? `${BASE_URL_IMG}${row.image}` : null
    );
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateCategoryAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getCategoryList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };

  const handleSubCategoryClick = (row) => {
    console.log(row, "dfjndkjfjijfrgui")
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");

    // Setting that we are adding a sub category
    setValue("addSub", true);
    setValue("selectedRow", row);

    // Fill fields from parent category
    setValue("category", row?.name);
    setValue("order", row?.order);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });

    // Keep existing subcategory list
    setValue(
      "subCategoryList",
      row?.subcategory?.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    );

    // ❗ MOST IMPORTANT – KEEP ONLY THIS FIELD EMPTY
    setValue("subCategory", "");
  };


  const handleSubCategoryChange = (sel) => { };
  // const resetF = () => {
  //   setMode("Add")
  //   setValue("category_image", null);
  //   setValue("category", "");
  //   setValue("status", null);
  //   setValue("addSub", false);
  //   setValue("category_image", null);
  //   setValue("category_img", null);
  //   setValue("order", "");
  //   setValue("addSub", false);
  // };
  const resetF = () => {
    reset();
    setMode("Add");
    setValue("addSub", false);
    setValue("category_image", null);
    setMode("Add")
    setValue("category_image", null);
    setValue("category", "");
    setValue("status", null);
    setValue("addSub", false);
    setValue("category_image", null);
    setValue("category_img", null);
    setValue("order", "");
    setValue("addSub", false);
  };

  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));

  return (
    <>
      <Head title={"Category | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5  text-center">
              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}> Category
                </OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Category"}
                            name={"category"}
                            placeholder={"Enter category name"}
                            required
                            min={2}
                            max={50}
                            disabled={watch("addSub")}
                          />
                        </Col>
                        {watch("addSub") ? (
                          <>
                            <Col md="12">
                              <div className="form-group mt-2">
                                <Label className="from-label" htmlFor="sub_category">
                                  Sub Category
                                </Label>
                                <div className="form-control-wrap">
                                  <Select
                                    className=""
                                    id="sub_category"
                                    options={watch("subCategoryList")}
                                    {...register("sub_category", {})}
                                    onChange={(e) => handleSubCategoryChange(e)}
                                    value={watch("sub_category")}
                                  />
                                  {errors.sub_category && (
                                    <span
                                      className="invalid"
                                      style={{
                                        color: "#e85347",
                                        fontSize: "11px",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {errors?.sub_category?.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col md="12" className={``}>
                              <MyInput
                                register={register}
                                watch={watch}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                                title={"Sub Category Name"}
                                name={"subCategory"}
                                placeholder={"Enter sub category name"}
                                required
                                min={2}
                                max={50}
                              />
                            </Col>
                          </>
                        ) : null}
                        <Col md="12">
                          <ImageUpload
                            setError={setError}
                            id="category_image"
                            watch={watch}
                            label={"Upload Category Image"}
                            errors={errors}
                            register={register}
                            trigger={trigger}
                            clearErrors={clearErrors}
                            image={"category_img"}
                            image_url={"category_image"}
                            setValue={setValue}
                            handleImageOpenPreview={handleImageOpenPreview}
                            required
                            getValues={getValues}
                          /></Col>
                        {/* Order */}

                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Order"}
                            name={"order"}
                            placeholder={"Enter category order"}
                            required
                            min={1}
                            max={2}
                            inputPattern={/[^0-9]/g}
                            pattern={/^[1-9][0-9]{0,2}$/}
                            patternMsg={"Enter a Order greater than 0 and up to 99"}
                          />
                        </Col>
                        <Col md={`12`}>
                          <Status register={register} watch={watch} setValue={setValue} trigger={trigger} errors={errors} />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>

              {/* Offcanvas (Right Side) */}
            </div>
          </>

          <SubCategoryTable
            title="Category List"
            data={data}
            publicButton={false}
            columns={[
              { key: "image", label: "Name", type: "image" },
              { key: "order", label: "Order" },
              // { key: "name", label: "Name" },
              //   { key: "meta_tags", label: "Meta" },
            ]}
            searchKeys={["name", "order"]}
            nameColumn={"name"}
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            selectorDeleteUser={selectorDeleteUser}
            selectorSuspendUser={selectorSuspendUser}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetF}
            handleImageOpenPreview={handleImageOpenPreview}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            handleTogglePublish={handleTogglePublish}
            handleSubCategoryClick={handleSubCategoryClick}
            isLoading={isLoading}
          />

          {/* <MyDataTable data={data || []} columns={column} title={"Product List"} isLoading={isLoading} /> */}
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default Category;
